var _rect, _rect2, _rect3, _path, _circle, _circle2, _rect4, _rect5, _rect6, _rect7, _circle3, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 159,
    height: 61,
    viewBox: "0 0 159 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8.854,
    y: 48.273,
    width: 32.172,
    height: 12.025,
    rx: 6.012,
    fill: "#E4F4FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10.99,
    y: 12.188,
    width: 16.015,
    height: 12.011,
    rx: 6.006,
    fill: "#E4F4FF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 125.039,
    y: 0.176,
    width: 12.025,
    height: 12.025,
    rx: 6.012,
    fill: "#E4F4FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.171.176a6.012 6.012 0 00-.126 12.023h21.47a6.012 6.012 0 010 12.025H48.216 103.202a6.013 6.013 0 01.06-12.024h5.204a6.012 6.012 0 005.902-6.012 6.012 6.012 0 00-6.012-6.012H44.171zm12.537 48.099a6.012 6.012 0 00.125 12.023h51.523a6.012 6.012 0 00.125-12.023H91.794c-.042 0-.084 0-.125-.002h-.318c.054 0 .108-.002.161-.005a6.013 6.013 0 01.004-12.012 6.438 6.438 0 00-.146-.005h.296l.128-.001h23.731l.127.001h5.764a6.013 6.013 0 100-12.024H35.889a6.012 6.012 0 00-.127 12.023h21.79a6.012 6.012 0 010 12.025h-.844z",
    fill: "#E4F4FF"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 155.083,
    cy: 18.101,
    r: 1.767,
    stroke: "#E4F4FF",
    strokeWidth: 2.605
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.07,
    cy: 37.597,
    r: 1.767,
    stroke: "#E4F4FF",
    strokeWidth: 2.605
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 137.105,
    y: 47.57,
    width: 7.474,
    height: 1.335,
    rx: 0.667,
    fill: "#E4F4FF"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 141.51,
    y: 44.5,
    width: 7.474,
    height: 1.335,
    rx: 0.667,
    transform: "rotate(90 141.51 44.5)",
    fill: "#E4F4FF"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 13.627,
    y: 2.07,
    width: 5.605,
    height: 1.335,
    rx: 0.667,
    fill: "#E4F4FF"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 17.098,
    width: 5.605,
    height: 1.335,
    rx: 0.667,
    transform: "rotate(90 17.098 0)",
    fill: "#E4F4FF"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 72.974,
    cy: 27.337,
    r: 24.351,
    fill: "#fff",
    stroke: "#32A3F5",
    strokeWidth: 2.605
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.299 28.833l8.734 8.734 18.716-18.715",
    stroke: "#32A3F5",
    strokeWidth: 2.605,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessTick);
export default __webpack_public_path__ + "static/media/success-tick.682b29a6.svg";
export { ForwardRef as ReactComponent };